import * as React from 'react'
import { TextInput } from 'react-admin'
import EmailIcon from '@mui/icons-material/MailOutline'
import { TwoColumnInput } from 'shared/molecules/TwoColumnInput'

// import { SlackChannelConfigInputs } from './types/SlackChannel';
// import slackLogo from 'https://api.iconify.design/mdi-slack.svg';

const Inputs = (props) => {
  return (
    <>
      <TwoColumnInput title="Email" description="The email address to send notifications on this channel to.">
        <TextInput {...props} source="config.email" label="Email" />
      </TwoColumnInput>
    </>
  )
}

// https://iconify.design/icon-sets/mdi/slack.html
export default class EmailChannelType {
  static Name = 'Email'
  static Icon = (<EmailIcon />)
  static Inputs = Inputs
  static summaryFor(channel) {
    return `Email to ${channel?.config?.email}`
  }
}
